import React from "react";
import styles from "./Formats.module.css";
import { getCurateResourceIcon, getCurateResourceTypeLabel } from "../../../Helpers/fileIcon";
import { CurateResource } from "../../../Types/Curate/CurateResource";

type CurateResourceTilesProps = {
  resources: CurateResource[];
  resourceClicked?: (resource: CurateResource) => void;
};

const tileMeta = (resource: CurateResource): string => {
  const label = getCurateResourceTypeLabel(resource);
  return resource.page && resource.page >= 1 ? `${label} · Page ${resource.page}` : label;
};

const tileTitle = (resource: CurateResource): string => {
  if (resource.page && resource.page >= 1) {
    return `Opens at page ${resource.page}`;
  }

  return resource.Description || resource.Title;
};

const CurateResourceTiles = ({ resources, resourceClicked }: CurateResourceTilesProps) => {
  if (!resources?.length) {
    return null;
  }

  return (
    <details className={styles.resourcesSection}>
      <summary className={styles.resourcesSummary}>
        <span className={styles.resourcesSummaryLabel}>In order of most priority, here are some resources you may find helpful</span>
        <span className={styles.resourcesBadge}>{resources.length}</span>
        <span className={styles.collapsedPills} aria-label="Resource shortcuts">
          {resources.map((resource) => (
            <button
              type="button"
              key={`pill-${resource.providerId ?? "curate"}-${resource.id}`}
              className={styles.resourcePill}
              onClick={(event) => {
                // Keep the details toggle from eating resource clicks in the summary row.
                event.preventDefault();
                event.stopPropagation();
                resourceClicked?.(resource);
              }}
              onPointerDown={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
              title={tileTitle(resource)}
            >
              <img
                src={getCurateResourceIcon(resource)}
                alt=""
                className={styles.resourcePillIcon}
                aria-hidden
              />
              <span className={styles.resourcePillText}>{resource.Title}</span>
              <span className={styles.resourcePillMeta}>{tileMeta(resource)}</span>
            </button>
          ))}
        </span>
      </summary>
      <div className={styles.resources}>
        {resources.map((resource) => (
          <button
            type="button"
            key={`${resource.providerId ?? "curate"}-${resource.id}`}
            className={styles.resourceTile}
            onClick={() => resourceClicked?.(resource)}
            title={tileTitle(resource)}
          >
            <img
              src={getCurateResourceIcon(resource)}
              alt=""
              className={styles.resourceTileIcon}
              aria-hidden
            />
            <span className={styles.resourceTileBody}>
              <span className={styles.resourceTileTitle}>{resource.Title}</span>
              <span className={styles.resourceTileMeta}>{tileMeta(resource)}</span>
            </span>
          </button>
        ))}
      </div>
    </details>
  );
};

export default React.memo(CurateResourceTiles);
